import { render, staticRenderFns } from "./trainResult.vue?vue&type=template&id=396fb42f&scoped=true&"
import script from "./trainResult.vue?vue&type=script&lang=js&"
export * from "./trainResult.vue?vue&type=script&lang=js&"
import style0 from "./trainResult.vue?vue&type=style&index=0&id=396fb42f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396fb42f",
  null
  
)

export default component.exports